import { SonarTagDisplay } from '@ui/tags';
import { When } from 'react-if';

import { Button, Menu } from 'antd';
import { COPY_GENERIC, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React, { useMemo } from 'react';
import { SearchGroup, SearchOptionGroup } from './DataDictionarySearch';
import { useBoolean, useTags } from '@hooks';

const tagItemsGroup = {
	key: 'title',
	label: COPY_SPECIFIC.TAGS,
	type: 'group'
};

export interface QuickAccessTagsProps {
	onSelect: (tagId: number) => void;
}

export const QuickAccessTags: React.FC<QuickAccessTagsProps> = ({ onSelect }) => {
	const [ showAllTags, setShowAllTags ] = useBoolean(false);

	const tags = useTags();

	const tagItems: Array<SearchGroup> = useMemo(() => [ {
		...tagItemsGroup,
		children: (showAllTags ? tags : tags.slice(0, 10))
			.map(({ id }) =>
				({
					group: SearchOptionGroup.Tag,
					key: String(id),
					label: <SonarTagDisplay
						noClick
						tagId={ id } />,
					value: id
				}))
	} ], [ showAllTags, tags ]);

	return (
		<div>
			<Menu
				className='quick-access-menu'
				items={ tagItems }
				mode='inline'
				onClick={ (info) => {
					onSelect(Number(info.key));
				} } />
			<When condition={ tags.length > 10 }>
				<Button
					className='show-all'
					onClick={ setShowAllTags.toggle }
					type='link'>
					{ showAllTags ? COPY_GENERIC.SHOW_LESS : COPY_GENERIC.SHOW_ALL }
				</Button>
			</When>
		</div>
	);
};
